import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { AoiService } from '../../../services/aoi.service';
import { GisToolsService } from '../../../services/gis-tools.service';
import { BaseComponent } from '../../base.component';
var InterstateComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InterstateComponent, _super);
    function InterstateComponent(_vcr, gisToolsService, aoiService, cdr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.gisToolsService = gisToolsService;
        _this.aoiService = aoiService;
        _this.cdr = cdr;
        _this.activate = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_1, _a, _b, _c, _d, route, routeNumber, error_1;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (this.isActive) {
                            return [2 /*return*/];
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, 4, 5]);
                        _b = this;
                        return [4 /*yield*/, this.gisToolsService.getInterstatesByNetworkIndicator()];
                    case 2:
                        _b.routes = _e.sent();
                        this.interstates = [];
                        try {
                            for (_c = tslib_1.__values(this.routes), _d = _c.next(); !_d.done; _d = _c.next()) {
                                route = _d.value;
                                routeNumber = route.stateRouteNumber.replace(/^0+/, '');
                                if (!this.interstates.includes(routeNumber)) { // filter list to distinct routeNumbers
                                    this.interstates.push(routeNumber);
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.cdr.detectChanges();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _e.sent();
                        this.readyProblem(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isReady();
                        this.isActive = true;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.reset = function () {
            _this._interstate = null;
        };
        _this.addResultToMap = function () {
            var routeNumber = _this.interstate;
            if (routeNumber.length === 2) {
                routeNumber = '00' + routeNumber;
            }
            else if (routeNumber.length === 3) {
                routeNumber = '0' + routeNumber;
            }
            var searchCriteria = {
                type: 'route',
                title: "Route (" + routeNumber + ")",
                stateRouteNumber: routeNumber
            };
            _this.aoiService.setSearchCriterias([searchCriteria]);
        };
        return _this;
    }
    Object.defineProperty(InterstateComponent.prototype, "interstate", {
        get: function () {
            return this._interstate;
        },
        set: function (route) {
            this._interstate = route;
        },
        enumerable: true,
        configurable: true
    });
    return InterstateComponent;
}(BaseComponent));
export { InterstateComponent };
